import {
    SET_TOPOLOGY_REQUEST,
    SET_TOPOLOGY_SUCCESS,
    SET_TOPOLOGY_ERROR,
    SET_TOPOLOGY_SPECIFIC_PAGE_REQUEST,
    SET_TOPOLOGY_SPECIFIC_PAGE_SUCCESS,
    SET_TOPOLOGY_SPECIFIC_PAGE_ERROR,
    SET_ALL_PRE_VALIDATION_CHECKS_REQUEST,
    SET_ALL_PRE_VALIDATION_CHECKS_SUCCESS,
    SET_ALL_PRE_VALIDATION_CHECKS_ERROR,
    SET_START_EXECUTION_REQUEST,
    SET_START_EXECUTION_SUCCESS,
    SET_START_EXECUTION_ERROR,
    SET_STOP_EXECUTION_REQUEST,
    SET_STOP_EXECUTION_SUCCESS,
    SET_STOP_EXECUTION_ERROR,

    SET_UPLOAD_TOPOLOGY_FILE_REQUEST,
    SET_UPLOAD_TOPOLOGY_FILE_SUCCESS,
    SET_UPLOAD_TOPOLOGY_FILE_ERROR,

    SET_DELETE_TOPOLOGY_DATA_REQUEST,
    SET_DELETE_TOPOLOGY_DATA_SUCCESS,
    SET_DELETE_TOPOLOGY_DATA_ERROR,

    SET_RESOURCES_TO_BE_CREATED_REQUEST,
    SET_RESOURCES_TO_BE_CREATED_SUCCESS,
    SET_RESOURCES_TO_BE_CREATED_ERROR,

    SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_REQUEST,
    SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_SUCCESS,
    SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_ERROR,
} from './../../../constants/closeLoop/topology/index';

const initialState = {
    loading: false,
    error: '',
    message: '',
    validationError: '',
    items: [],
    pages: [],
    page: 1
};

export const topologyReducer = (state=initialState, action) => {
    switch(action.type) {
        case SET_TOPOLOGY_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                message: '',
                validationError: '',
                items: [],
                pages: [],
                page: 1
            }

        case SET_TOPOLOGY_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                message: '',
                validationError: '',
                items: action.items,
                pages: action.pages,
                page: 1
            }

        case SET_TOPOLOGY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: '',
                validationError: '',
                items: [],
                pages: [],
                page: 1
            }

        case SET_TOPOLOGY_SPECIFIC_PAGE_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                message: '',
                validationError: '',
                items: [],
                pages: [],
                page: 1
            }

        case SET_TOPOLOGY_SPECIFIC_PAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                message: '',
                validationError: '',
                items: action.items,
                pages: action.pages,
                page: action.page
            }

        case SET_TOPOLOGY_SPECIFIC_PAGE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: '',
                validationError: '',
                items: [],
                pages: [],
                page: 1
            }

        case SET_ALL_PRE_VALIDATION_CHECKS_REQUEST:
            return {
                ...state,
                loading: false,
                error: "",
                message: '',
                validationError: '',
                items: state.items.map((item) => {
                    if(item['job_id'] === action.topologyId) {
                        item['validate'] = {
                            loading: true
                        }
                        return item;
                    }
                    return item;
                }),
                pages: state.pages,
                page: state.page
            }

        case SET_ALL_PRE_VALIDATION_CHECKS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: "",
                message: '',
                validationError: '',
                items: state.items.map((item) => {
                    if(item['job_id'] === action.topologyId) {
                        item['execution'] = 'Start';
                        item['validate'] = {
                            loading: false,
                            config: action.config
                        }
                        return item;
                    }
                    return item;
                }),
                pages: state.pages,
                page: state.page
            }

        case SET_ALL_PRE_VALIDATION_CHECKS_ERROR:
            return {
                ...state,
                loading: false,
                error: '',
                message: '',
                validationError: action.payload,
                items: state.items.map((item) => {
                    if(item['job_id'] === action.topologyId) {
                        item['execution'] = 'Validate';
                        item['validate'] = {
                            loading: false
                        }
                        return item;
                    }
                    return item;
                }),
                pages: state.pages,
                page: state.page
            }

        case SET_START_EXECUTION_REQUEST:
            return {
                ...state,
                loading: false,
                error: '',
                message: '',
                validationError: '',
                items: state.items.map((item) => {
                    if(item['job_id'] === action.topologyId) {
                        const oldValidateInfo = item['validate'];
                        item['execution'] = 'Start';
                        item['validate'] = {
                            ...oldValidateInfo,
                            loading: true
                        }
                        return item;
                    }
                    return item;
                }),
                pages: state.pages,
                page: state.page
            }
            case SET_STOP_EXECUTION_REQUEST:
                    return {
                        ...state,
                        loading: false,
                        error: '',
                        message: '',
                        validationError: '',
                        items: state.items.map((item) => {
                            if(item['job_id'] === action.topologyId) {
                                const oldValidateInfo = item['validate'];
                                item['execution'] = 'Stopp';
                                item['validate'] = {
                                    ...oldValidateInfo,
                                    loading: true
                                }
                                return item;
                            }
                            return item;
                        }),
                        pages: state.pages,
                        page: state.page
                    }
        case SET_START_EXECUTION_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                message: action.message,
                validationError: '',
                items: state.items.map((item) => {
                    if(item['job_id'] === action.topologyId) {
                        const oldValidateInfo = item['validate'];
                        item['execution'] = 'Stop';
                        item['validate'] = {
                            ...oldValidateInfo,
                            loading: false
                        }
                        return item;
                    }
                    return item;
                }),
                pages: state.pages,
                page: state.page
            }
            case SET_STOP_EXECUTION_SUCCESS:
                    return {
                        ...state,
                        loading: false,
                        error: '',
                        message: action.message,
                        validationError: '',
                        items: state.items.map((item) => {
                            if(item['job_id'] === action.topologyId) {
                                const oldValidateInfo = item['validate'];
                                item['execution'] = 'Validate';
                                item['validate'] = {
                                    ...oldValidateInfo,
                                    loading: false
                                }
                                return item;
                            }
                            return item;
                        }),
                        pages: state.pages,
                        page: state.page
                    }

        case SET_START_EXECUTION_ERROR:
            return {
                ...state,
                loading: false,
                error: '',
                message: '',
                validationError: action.payload,
                items: state.items.map((item) => {
                    if(item['job_id'] === action.topologyId) {
                        const oldValidateInfo = item['validate'];
                        item['execution'] = 'Stop';
                        item['validate'] = {
                            ...oldValidateInfo,
                            loading: false
                        }
                        return item;
                    }
                    return item;
                }),
                pages: state.pages,
                page: state.page
            }
            case SET_STOP_EXECUTION_ERROR:
                   return {
                       ...state,
                       loading: false,
                       error: '',
                       message: '',
                       validationError: action.payload,
                       items: state.items.map((item) => {
                           if(item['job_id'] === action.topologyId) {
                               const oldValidateInfo = item['validate'];
                               item['execution'] = 'Stop';
                               item['validate'] = {
                                   ...oldValidateInfo,
                                   loading: false
                               }
                               return item;
                           }
                           return item;
                       }),
                       pages: state.pages,
                        page: state.page
                    }

        case SET_UPLOAD_TOPOLOGY_FILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                message: '',
                validationError: '',
                items: state.items,
                pages: state.pages,
                page: state.page
            }

        case SET_UPLOAD_TOPOLOGY_FILE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                message: '',
                validationError: '',
                items: action.items,
                pages: action.pages,
                page: action.page
            }

        case SET_UPLOAD_TOPOLOGY_FILE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: '',
                validationError: '',
                items: [],
                pages: [],
                page: 1
            }

        case SET_DELETE_TOPOLOGY_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                message: '',
                validationError: '',
                items: state.items,
                pages: state.pages,
                page: state.page
            }

        case SET_DELETE_TOPOLOGY_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                message: '',
                validationError: '',
                items: action.items,
                pages: action.pages,
                page: action.page
            }

        case SET_DELETE_TOPOLOGY_DATA_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: '',
                validationError: '',
                items: [],
                pages: [],
                page: 1
            }

        default:
            return state
    }
}


const resourcesInitialState = {
    loading: false,
    error: '',
    resources: []
}


export const resourcesCreatedReducers = (state=resourcesInitialState, action) => {
    switch(action.type) {
        case SET_RESOURCES_TO_BE_CREATED_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                resources: []
            }

        case SET_RESOURCES_TO_BE_CREATED_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                resources: action.resources
            }

        case SET_RESOURCES_TO_BE_CREATED_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
                resources: []
            }

        default:
            return state;
    }
}

const downloadTopologyState = {
    loading: false,
    error: '',
    fileName: ''
}

export const downloadTopologyFile = (state=downloadTopologyState, action) => {
    switch(action.type) {
        case SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                fileName: ''
            }

        case SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                fileName: action.payload
            }

        case SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
                fileName: ''
            }

        default:
            return state;
    }
}